import gql from 'graphql-tag'

export default gql`
mutation createGuide($input: GuideInput) {
  createGuide(input: $input) {
    id
    type
    status
    img_header_desktop
    img_header_mobile
    img_medallion
    file_audio_guide
    duration
    place
    order
    details {
      title
      content
			instruction_title
      instruction
      medallion_title
      push_label
      century_1
      century_2
      language_code
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/guide/create.js